var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPackage = function SvgPackage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.111 17.94v-5.48L5.778 9.68v5.48zm1.778 0 5.333-2.78V9.68l-5.333 2.78zm-1.778 1.84L4.89 16.56q-.423-.22-.656-.58a1.44 1.44 0 0 1-.233-.8V8.82q0-.44.233-.8t.656-.58l6.222-3.22a1.9 1.9 0 0 1 1.778 0l6.222 3.22q.422.22.656.58.233.36.233.8v6.36q0 .44-.233.8t-.656.58l-6.222 3.22a1.9 1.9 0 0 1-1.778 0m4.445-10.56 1.71-.88L12 5.6l-1.733.9zM12 11.08l1.733-.9-5.266-2.74-1.734.9z"
  })));
};
export default SvgPackage;